import { GraphQLClient, gql } from "graphql-request";

import { getApiUrl } from "../utils/get-api-url";

const getClient = () => {
  const apiUrl = getApiUrl("docusign");
  return new GraphQLClient(apiUrl, {
    credentials: "include"
  });
};

const docusignStatusQuery = gql`
  query DocusignStatus($id: String!) {
    docusignStatus(policyId: $id) {
      id
      documentType
      documentStatus
      detailedRecipients {
        email
        name
        recipientType
        recipientId
        status
      }
      dates {
        name
        value
      }
      url
      apiUserId
    }
  }
`;

export const docusignStatusGraphql = {
  docusignStatus: vars =>
    getClient()
      .request(docusignStatusQuery, vars)
      // most requests will error, let's just return the data
      .catch(err => err.response?.data || Promise.reject(err))
};
